import { render, staticRenderFns } from "./BaseTemplate.vue?vue&type=template&id=4c7c3e1f&scoped=true"
import script from "./BaseTemplate.vue?vue&type=script&lang=js"
export * from "./BaseTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7c3e1f",
  null
  
)

export default component.exports